import { fetchBooks } from '../../fetch/documents.js';
import { selectLoadingRecentDocuments } from '../../reducers/recentDocumentsReducer.js';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Slider from '../slider/Slider.js';
import { selectLangObj } from '../../reducers/langReducer.js';
import SliderElement from '../slider/SliderElement.js';
import SliderItem from '../../models/SliderItem.js';
import DocumentSlider from '../slider/DocumentSlider.js';
import { selectBooks } from '../../reducers/booksReducer.js';
import MoreInfo from './MoreInfo.js';
import GridType from '../../models/GridType.ts';


function BooksSlider(props) {
  const books = useSelector(selectBooks);
  const dispatch = useDispatch();
  const langObj = useSelector(selectLangObj);

  const appendItems = () => {
    dispatch(fetchBooks());
  }
  useEffect(() => {

    appendItems();
  }, []);

  function getItems(recentDocuments) {


    return recentDocuments.map(e => { return new SliderItem(e.рбр, e.наслов, e.линкП, e.линк, e.датум, e.прикупио); }).map(e => {

      return (
        <SliderElement auto={false} key={e.url} data={e}></SliderElement>
      )
    })
  }

  return (


    <DocumentSlider 
    moreElement={<MoreInfo  moreLink={"/Grid/" + GridType.Book}/>}
      title={langObj["Books"]} appendItems={appendItems} getItems={() => getItems(books)}  ></DocumentSlider>
  );
}

export default BooksSlider;
